/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppPageDescription.vue?vue&type=template&id=25d5c739&scoped=true"
import script from "./AppPageDescription.ts?vue&type=script&lang=ts&external"
export * from "./AppPageDescription.ts?vue&type=script&lang=ts&external"
import style0 from "./AppPageDescription.vue?vue&type=style&index=0&id=25d5c739&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d5c739",
  null
  
)

export default component.exports